export function getMarkerIdFromPrefixedId(prefixedId: string): string {
    return prefixedId.split('_').pop();
}

export function getUserName(userData): string {
    
    const firstName = userData.first_name || "";
    const lastName = userData.last_name || "";
    
    return (firstName + " " + lastName).trim() || userData.username;
}
